import getStore from '../store';
import { mutator } from 'satcheljs';
import { setSearchResultsEdited } from '../actions/searchResultStoreActions';

/**
 * Mutator action to take when search results are edited/deleted.
 */
export let setSearchResultsEditedMutator = mutator(setSearchResultsEdited, action => {
    let store = getStore();
    action.isDeleteAction
        ? (store.searchResults[store.selectedItemId].isDeleted = true)
        : (store.searchResults[store.selectedItemId].isEdited = true);
    store.editedResultsCount = ++store.editedResultsCount;

    if (action.isBirthdayUpdate != undefined && action.isBirthdayUpdate == true) {
        store.searchResults[store.selectedItemId].isBirthdayUpdated = true;
    }
});
